/**
 * 前端监控上报逻辑
 *
 * v1.4 改造：接入 SLS WebTracking 匿名模式用于临时验证。
 * 验证完成后，应在 slsTracker.js 中切换到 STS 安全模式。
 */
import { initSlsTracker, sendSlsLog } from '../utils/slsTracker';

/**
 * 获取页面类型
 * @param {string} pagePath - 页面路径
 * @returns {string} 页面类型
 */
function getPageType(pagePath) {
  if (!pagePath) {
    return 'unknown';
  }

  if (pagePath.indexOf('/share') !== -1) {
    return 'share';
  }

  if (pagePath.indexOf('/make') !== -1 || pagePath.indexOf('/edit') !== -1 || pagePath.indexOf('/editor') !== -1) {
    return 'editor';
  }

  return pagePath.replace(/\//g, '_');
}

/**
 * 构建监控上下文
 * @returns {object} 监控上下文
 */
function buildFrontendMonitorContext() {
  let pageUrl = '';
  let pagePath = '';

  if (typeof window !== 'undefined' && window.location) {
    pageUrl = window.location.href || '';
    pagePath = window.location.pathname || '';
  }

  return {
    projectType: 'mainloading',
    pageType: getPageType(pagePath),
    pageUrl,
    pagePath,
    mainloadingMode: 'serve',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent || '' : '',
    timestamp: Date.now()
  };
}

/**
 * 初始化 SLS Tracker
 *
 * 临时验证阶段使用匿名模式，配置独立的验证 Logstore。
 * TODO: 验证完成后切换到 STS 模式 + 正式 Logstore。
 */
initSlsTracker({
  host: 'cn-shenzhen.log.aliyuncs.com',
  project: 'liti-h5-mainloading',
  logstore: 'normal'
});

export function useMonitor() {
  return {
    /**
     * 发送前端监控
     * @param {object} payload - 监控数据
     */
    sendFrontendMonitor(payload) {
      const logData = Object.assign({}, buildFrontendMonitorContext(), payload || {});

      // 实际上报 SLS
      sendSlsLog(logData);
    }
  };
}
